module.exports = __webpack_public_path__ + "static/media/1.ee980332.png";